function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './FiltersSelected.css';
import React, { useContext, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { addQueryStringMultiple } from '../../Listing/index';
import { stateTofacetsObj } from '../ListingOffersAndDeals';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { ReactComponent as IconClose } from '../../../resources/icons/close-tag.svg';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import { DATE_RANGE_FACET_NAME } from '../constants';
const commonStyles = "c1pmfytf";
const ltrStyles = "l1xb2ro9";
const rtlStyles = "rx6ktd5";
const FiltersSelected = _ref => {
  let {
    filterState,
    setFilter,
    resetFilters,
    clearText,
    setListingFilter,
    facets,
    resetAndSubmitFilters,
    eventsAnalytics,
    params
  } = _ref;
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const history = useHistory();
  const filtersToDisplay = useMemo(() => Object.keys(filterState), [filterState]);
  if (!filtersToDisplay.length) return null;
  let selectedItemsLength = 0;
  filtersToDisplay.forEach(item => {
    selectedItemsLength += filterState[item].value.length;
  });
  if (!selectedItemsLength) return null;
  const removeFilterAnalyticsClick = text => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['removeFilterAnalytics'], params), text);
  };
  const clearAllHandler = () => {
    resetAndSubmitFilters();
    const newState = _objectSpread({}, filterState);
    const finalQSObject = stateTofacetsObj(newState);
    const url = new URL(window.location.href);
    Object.keys(finalQSObject).forEach(facet => {
      if (finalQSObject[facet] && facet !== DATE_RANGE_FACET_NAME) {
        url.searchParams.delete(facet);
      }
    });
    history.replace(`${history.location.pathname}${url.search}${url.hash}`);
    resetFilters(newState);
    setListingFilter();
    removeFilterAnalyticsClick(clearText);
  };
  return /*#__PURE__*/React.createElement("ul", {
    className: `filters__selected ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, filtersToDisplay.map((filterFieldTitle, index) => {
    if (filterState[filterFieldTitle].facetName === DATE_RANGE_FACET_NAME) {
      if (filterState[filterFieldTitle].valueReadableString) {
        return /*#__PURE__*/React.createElement("li", {
          key: index,
          className: "filters__selected-item"
        }, filterState[filterFieldTitle].valueReadableString, /*#__PURE__*/React.createElement("button", {
          className: "filters__selected-remove-btn",
          onClick: () => {
            //set empty value => OfferAndDealDatePicker tracks value and clear it of its empty
            setFilter({
              [filterFieldTitle]: _objectSpread(_objectSpread({}, filterState[filterFieldTitle]), {}, {
                value: '',
                valueReadableString: ''
              })
            });
          }
        }, /*#__PURE__*/React.createElement(IconClose, null)));
      }
    } else {
      return filterState[filterFieldTitle].value.filter(tagName => facets[filterState[filterFieldTitle].facetName] && facets[filterState[filterFieldTitle].facetName][tagName]).map(tagName => /*#__PURE__*/React.createElement("li", {
        className: "filters__selected-item",
        key: tagName
      }, tagName, /*#__PURE__*/React.createElement("button", {
        className: "filters__selected-remove-btn",
        onClick: () => {
          const newValues = filterState[filterFieldTitle].value.filter(item => item !== tagName);
          const selected = {
            [tagName]: false
          };
          setFilter({
            [filterFieldTitle]: _objectSpread(_objectSpread({}, filterState[filterFieldTitle]), {}, {
              value: newValues
            })
          });
          removeFilterAnalyticsClick(tagName);
          addQueryStringMultiple(filterState[filterFieldTitle].facetName, selected, history);
          setListingFilter();
        }
      }, /*#__PURE__*/React.createElement(IconClose, null))));
    }
  }), /*#__PURE__*/React.createElement("li", {
    className: "filters__selected-item-clear"
  }, /*#__PURE__*/React.createElement("button", {
    className: "filters__selected-clear-btn",
    onClick: clearAllHandler
  }, clearText)));
};
export default FiltersSelected;